
import { Component, Vue, Prop } from 'vue-property-decorator'
import TipsPopup from '@/components/tipsPopup/index.vue'
import {
  formatterPositiveInteger,
  formatterMoney,
  formatterPercent
} from '@/utils/util'
import {
  limitTypeList,
  prizeTypeList,
  defaultPrize,
  defaultLimit
} from './../../index'

interface PrizeItem {
  prizeName: string
  prizePoint: string
  prizeCost: string
  prizeAmount: string
  prizeWinRate: string
  prizeType: 1 | 2 // 奖品类型(1自定义2积分)
}


@Component({
  components: { TipsPopup }
})
class StepPrizeSetting extends Vue {
  @Prop({ default: () => ({}) }) formData!: any

  formatterPositiveInteger = formatterPositiveInteger
  formatterMoney = formatterMoney
  formatterPercent = formatterPercent
  limitTypeList = limitTypeList
  prizeTypeList = prizeTypeList

  prizeCreateTypeList = [
    {
      label: '自动填充',
      value: 1
    },
    {
      label: '手动填充',
      value: 2
    }
  ]

  localForm: any = {
    prizeCreateType: 1,
    prizeList: [{ ...defaultPrize }],
    isParticipatePrize: 0, // 是否开启参与奖(1开启0关闭)
    participatePrizeType: 1, // 参与奖类型(1自定义2积分)
    participatePrizeTypeName: '',
    participatePrizeName: '',
    participatePrizePoint: '',
    isRequireWriteOff: 0, // 是否开启核销(1开启0关闭)
    budgetType: 1, // 预算金额类型(1固定预算2按营业额比例)，默认固定预算
    budgetMoney: '', // 奖品固定预算金额x元
    budgetRatio: '', // 奖品预算按营业额比例x%
    isLotteryLimit: 0, // 是否存在抽奖限制(1有抽奖限制0无抽奖限制)
    limitList: [{ ...defaultLimit }]
  }

  showParticipatePrizeTypePicker = false
  curLimitIndex = 0
  showLimitTypePicker = false
  showLimitPrizePicker = false
  tipsPopupContent = ''

  get limitPrizeList() {
    const list = this.localForm.prizeList.filter(
      (item) =>
        (item.prizeType == 1 && item.prizeName) ||
        (item.prizeType == 2 && item.prizePoint)
    )
    return list.map((item) => {
      return {
        label: item.prizeType == 1 ? item.prizeName : `${item.prizePoint}积分`,
        sortNumber: item.sortNumber
      }
    })
  }

  created() {
    // 初始化本地数据
    let {
      participatePrizeType = 1,
      prizeList = [],
      limitList = []
    } = this.formData
    const participatePrizeTypeObj = this.prizeTypeList[participatePrizeType - 1]

    prizeList =
      prizeList.length > 0
        ? prizeList.filter(
            (item) => item.prizeLevel != '参与奖' && item.prizeType
          )
        : [{ ...defaultPrize }]

    limitList =
      limitList.length > 0
        ? limitList.map((item) => {
            const limitObj = limitTypeList.find(
              (l) => l.value === Number(item.limitType)
            )
            return {
              ...item,
              limitTypeName: limitObj?.label || ''
            }
          })
        : [{ ...defaultLimit }]

    this.localForm = {
      ...this.localForm,
      ...(this.formData || {}),
      participatePrizeTypeName: participatePrizeTypeObj.label,
      prizeList,
      limitList
    }
    this.onInputChange()
  }

  // 获取奖品类型标签
  getPrizeTypeLabel(prizeType: number) {
    const item = prizeTypeList.find((p) => p.value === Number(prizeType))
    return item.label || '--'
  }

  onSelectPrizeCreateType(value) {
    if (this.localForm.prizeCreateType == value) return
    this.localForm.prizeCreateType = value
    this.onInputChange()
    this.clearFormValidate(['prizeList'])
  }

  onSelectBudgetType() {
    this.clearFormValidate(['budgetMoney', 'budgetRatio'])
  }

  // 添加奖品
  onAddPrize(prizeType) {
    const length = this.localForm.prizeList.length
    if (length >= 4) {
      this.$toast('最多新增四个奖品')
      return
    }
    const curSortNumber = this.localForm.prizeList[length - 1].sortNumber ?? 1
    this.localForm.prizeList.push({
      ...defaultPrize,
      prizeType, // 奖品类型(1自定义2积分)
      sortNumber: Number(curSortNumber) + 1
    })
    this.onInputChange()
  }

  // 删除奖品
  onDeletePrize(index: number, sortNumber: number) {
    if (this.localForm.prizeList.length <= 1) {
      this.$toast('至少录入一个奖品')
      return
    }
    const isUsedLimitList = this.localForm.limitList.some((item) => item.sortNumber == sortNumber)
    this.tipsPopupContent = isUsedLimitList ? '该奖品已被引用，删除将清除关联，是否继续？' : '确认要删除该奖品吗？删除后不可撤销，需重新创建'
    ;(this.$refs.tipsPopupRef as any).showPopup({ index, isUsedLimitList, sortNumber })
  }

  onDeletePrizeTipsConfirm({ index, isUsedLimitList, sortNumber }) {
    this.localForm.prizeList.splice(index, 1)
    if (isUsedLimitList) {
      this.localForm.limitList.forEach(item => {
        if (item.sortNumber === sortNumber) {
          item.limitPrizeName = ''
        }
      })
    }
    this.onInputChange()
  }

  // 参与奖设置奖品类型确认
  onParticipatePrizeTypeConfirm(obj: any) {
    this.localForm.participatePrizeType = obj.value
    this.localForm.participatePrizeTypeName = obj.label
    this.showParticipatePrizeTypePicker = false
    this.onInputChange()
  }

  onShowLimitTypePicker(index: number) {
    this.curLimitIndex = index
    this.showLimitTypePicker = true
  }

  // 限制类型确认
  onLimitTypeConfirm(obj: any) {
    const limitObj = this.localForm.limitList[this.curLimitIndex]
    limitObj.limitType = obj.value
    limitObj.limitTypeName = obj.label
    this.showLimitTypePicker = false
    this.onInputChange()
  }

  onShowlimitPrizePicker(index: number) {
    if (this.limitPrizeList.length == 0) {
      this.$toast('请先添加常规奖品')
      return false
    }
    this.curLimitIndex = index
    this.showLimitPrizePicker = true
  }

  // 可抽中奖品确认
  onLimitPrizeConfirm(obj: any) {
    const limitObj = this.localForm.limitList[this.curLimitIndex]
    limitObj.limitPrizeName = obj.label
    limitObj.sortNumber = obj.sortNumber
    this.showLimitPrizePicker = false
    this.onInputChange()
  }

  // 删除限制
  onDeleteLimit(index) {
    if (this.localForm.limitList.length <= 1) {
      this.$toast('至少录入一条限制')
      return
    }
    this.localForm.limitList.splice(index, 1)
    this.onInputChange()
  }

  // 新增限制
  onAddLimit() {
    this.localForm.limitList.push({ ...defaultLimit })
  }

  // 输入变化
  onInputChange() {
    this.$emit('update:formData', { ...this.localForm })
  }

  // 限制最小值（支持嵌套路径如 prizeList.0.prizeCost）
  limitMinValue(field: string, min: number) {
    const keys = field.split('.')
    let target: any = this.localForm
    for (let i = 0; i < keys.length - 1; i++) {
      target = target[keys[i]]
    }
    const lastKey = keys[keys.length - 1]
    const val = Number(target[lastKey])
    if (val < min) {
      target[lastKey] = `${min}`
      this.onInputChange()
    }
  }

  clearFormValidate(prop: string | string[]) {
    this.$emit('clearFormValidate', prop)
  }

  // 校验限制规则中的奖品是否有效
  validate() {
    const { isLotteryLimit, limitList } = this.localForm
    if (isLotteryLimit != 1) return true

    // 构建当前有效的奖品映射：sortNumber -> limitPrizeName
    const validPrizeMap = new Map()
    this.limitPrizeList.forEach((item) => {
      validPrizeMap.set(item.sortNumber, item.label)
    })

    // 校验每条限制规则中选中的奖品是否匹配当前奖品列表
    const isValid = limitList.every((item) => {
      if (!item.limitPrizeName) return true
      const curPrizeName = validPrizeMap.get(item.sortNumber)
      return curPrizeName === item.limitPrizeName
    })

    if (!isValid) {
      this.$toast('奖品发生变更，请重新选择')
      return false
    }
    return true
  }
}
export default StepPrizeSetting
